import React from "react";
import styled from "styled-components";
import { Box, Flex } from "rebass/styled-components";
import { HiAdjustments, HiX } from "react-icons/hi";

import { SliderStep } from "MVVM/Hooks/useClipQualityConfigs";
import { QualitySettingsSliders } from "../QualitySettingsSliders";

interface FullscreenSettingsOverlayProps {
  resolutionSlider: SliderStep[];
  framerateSlider: SliderStep[];
  blurSlider: SliderStep[];
  resIdx: number;
  fpsIdx: number;
  blurIdx: number;
  onResChange: (idx: number) => void;
  onFpsChange: (idx: number) => void;
  onBlurChange: (idx: number) => void;
  onSliderRelease: () => void;
  isStepAvailableFn: (settingKey: string, value: string | number) => boolean;
  hasAnyUnavailable: boolean;
  isOpen: boolean;
  onToggle: () => void;
}

export const FullscreenSettingsOverlay = ({
  resolutionSlider,
  framerateSlider,
  blurSlider,
  resIdx,
  fpsIdx,
  blurIdx,
  onResChange,
  onFpsChange,
  onBlurChange,
  onSliderRelease,
  isStepAvailableFn,
  hasAnyUnavailable,
  isOpen,
  onToggle,
}: FullscreenSettingsOverlayProps) => {
  return (
    <OverlayContainer>
      <ToggleSettingsButton onClick={onToggle}>
        {isOpen ? <HiX size={20} /> : <HiAdjustments size={20} />}
      </ToggleSettingsButton>

      {isOpen && (
        <SettingsPanel onClick={(e) => e.stopPropagation()}>
          <SettingsTitle>Clip Quality Settings</SettingsTitle>

          <QualitySettingsSliders
            resolutionSlider={resolutionSlider}
            framerateSlider={framerateSlider}
            blurSlider={blurSlider}
            resIdx={resIdx}
            fpsIdx={fpsIdx}
            blurIdx={blurIdx}
            onResChange={onResChange}
            onFpsChange={onFpsChange}
            onBlurChange={onBlurChange}
            onSliderRelease={onSliderRelease}
            isStepAvailableFn={isStepAvailableFn}
            hasAnyUnavailable={hasAnyUnavailable}
            variant="overlay"
          />
        </SettingsPanel>
      )}
    </OverlayContainer>
  );
};

const OverlayContainer = styled(Box)`
  left: 0;
  position: absolute;
  top: 0;
  z-index: 10;
`;

const ToggleSettingsButton = styled.button`
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  left: 12px;
  padding: 8px;
  position: absolute;
  top: 12px;
  transition: background 0.2s;
  z-index: 11;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

const SettingsPanel = styled(Flex)`
  backdrop-filter: blur(20px);
  background: rgba(0, 0, 0, 0.7);
  border-bottom-right-radius: 12px;
  flex-direction: column;
  gap: 0;
  max-width: 520px;
  padding: 52px 24px 20px;
  width: 520px;
`;

const SettingsTitle = styled(Box)`
  color: white;
  font-family: "Barlow", sans-serif;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`;
